module.exports = __webpack_public_path__ + "img/builder-35.b6933763.jpg";